import BaseDocumentRequest from "../../components/BaseDocumentRequest/BaseDocumentRequest";
import { trlConfig } from "../../components/BaseDocumentRequest/config/trlConfig";

const TravelRequestLocal = () => {
  return <BaseDocumentRequest {...trlConfig} />;
};

export default TravelRequestLocal;
